import React, { useEffect, useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import api from "../../api";
import Select from "react-select";

const ClassSectionWorkingDays = () => {
    const [form, setForm] = useState({
        class_id: "",
        section_id: "",
        working_days: "",
    });

    const [sessions, setSessions] = useState([]);
    const [classes, setClasses] = useState([]);
    const [sections, setSections] = useState([]);
    const [records, setRecords] = useState([]);
    const [msg, setMsg] = useState(null);
    const [loading, setLoading] = useState(false);
    const [editId, setEditId] = useState(null);

    // ================= INIT =================
    useEffect(() => {
        fetchSessions();
        fetchClasses();
    }, []);

    // ================= FETCH =================
    const fetchSessions = async () => {
        const res = await api.get("/school/academic_year/list");
        if (res.data?.data) setSessions(res.data.data);
    };

    const fetchClasses = async () => {
        const res = await api.get("/get-classes");
        if (res.data?.success) setClasses(res.data.data);
    };

    const fetchSections = async (classId) => {
        if (!classId) return;
        const res = await api.get(`/get-sections/${classId}`);
        if (res.data?.success) setSections(res.data.data);
    };

    const fetchRecords = async (classId, sectionId) => {
        if (!classId || !sectionId) return;

        const res = await api.get(
            `/working_days/list?class_id=${classId}&section_id=${sectionId}`
        );

        // ✅ FIX HERE
        setRecords(res.data?.data?.data || []);
    };


    // ================= SUBMIT =================
    const handleSubmit = async (e) => {
        e.preventDefault();
        setMsg(null);

        const { class_id, section_id, working_days } = form;

        if (!class_id || !section_id || !working_days) {
            return setMsg({ type: "error", text: "All fields are required" });
        }

        try {
            setLoading(true);

            const res = await api.post("/working_days/add", {
                class_id,
                section_id,
                working_days,
            });

            if (res.data?.status) {
                setMsg({ type: "success", text: res.data.message });

                // 🔁 refresh table
                await fetchRecords(class_id, section_id);

                // 🧹 clear ONLY input field (not filters)
                setForm((prev) => ({
                    ...prev,
                    working_days: "",
                }));

                setEditId(null);
            } else {
                setMsg({ type: "error", text: res.data.message });
            }
        } catch {
            setMsg({ type: "error", text: "Server error" });
        } finally {
            setLoading(false);
        }
    };

    // ================= EDIT =================
    const handleEdit = (row) => {
        setForm({
            class_id: row.class_id,
            section_id: row.section_id,
            working_days: row.working_days,
        });
        setEditId(row.id);
        fetchSections(row.class_id);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    // ================= UI =================
    return (
        <div style={{ background: "#f4f6f8", minHeight: "100vh", padding: 30 }}>
            <main style={{ maxWidth: 1000, margin: "auto" }}>

                {/* FORM */}
                <section style={cardStyle}>
                    <h2 style={titleStyle}>📅 Class & Section Working Days</h2>

                    {msg && (
                        <div style={{ color: msg.type === "error" ? "red" : "green" }}>
                            {msg.text}
                        </div>
                    )}

                    <form onSubmit={handleSubmit}>
                        <div style={formGrid}>

                            <FormGroup label="Class">
                                <Select
                                    options={classes.map((c) => ({
                                        value: c.id,
                                        label: c.class_name,
                                    }))}
                                    value={
                                        form.class_id
                                            ? {
                                                value: form.class_id,
                                                label:
                                                    classes.find((c) => c.id === form.class_id)
                                                        ?.class_name,
                                            }
                                            : null
                                    }
                                    onChange={(c) => {
                                        setForm({
                                            ...form,
                                            class_id: c?.value || "",
                                            section_id: "",
                                        });
                                        fetchSections(c?.value);
                                    }}
                                />
                            </FormGroup>

                            <FormGroup label="Section">
                                <Select
                                    options={sections.map((s) => ({
                                        value: s.id,
                                        label: s.section_name,
                                    }))}
                                    value={
                                        form.section_id
                                            ? {
                                                value: form.section_id,
                                                label:
                                                    sections.find((s) => s.id === form.section_id)
                                                        ?.section_name,
                                            }
                                            : null
                                    }
                                    onChange={(s) => {
                                        setForm({ ...form, section_id: s?.value || "" });
                                        fetchRecords(
                                            form.class_id,
                                            s?.value,
                                            form.academic_year_id
                                        );
                                    }}
                                />
                            </FormGroup>

                            <FormGroup label="Working Days">
                                <input
                                    type="number"
                                    value={form.working_days}
                                    onChange={(e) =>
                                        setForm({ ...form, working_days: e.target.value })
                                    }
                                    style={inputStyle}
                                />
                            </FormGroup>

                        </div>

                        <div style={{ textAlign: "right", marginTop: 20 }}>
                            <button style={buttonStyle} disabled={loading}>
                                {editId ? "Update" : "Save"}
                            </button>
                        </div>
                    </form>
                </section>

                {/* LIST */}
                <section style={cardStyle}>
                    <h2 style={titleStyle}>📋 Assigned Working Days</h2>

                    {records.length === 0 ? (
                        <p>No records found</p>
                    ) : (
                        <table style={tableStyle}>
                            <thead>
                                <tr>
                                    <th>Session</th>
                                    <th>Class</th>
                                    <th>Section</th>
                                    <th>Working Days</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {records.map((r) => (
                                    <tr key={r.id}>
                                        <td>{r.session_name}</td>
                                        <td>{r.class_name}</td>
                                        <td>{r.section_name}</td>
                                        <td>{r.working_days}</td>
                                        <td>
                                            <FaEdit
                                                style={{ cursor: "pointer", marginRight: 10 }}
                                                onClick={() => handleEdit(r)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </section>
            </main>
        </div>
    );
};

// ================= UI HELPERS =================
const FormGroup = ({ label, children }) => (
    <div>
        <label style={{ fontWeight: 500 }}>{label}</label>
        {children}
    </div>
);

const cardStyle = {
    background: "#fff",
    padding: 25,
    borderRadius: 12,
    marginBottom: 25,
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
};

const titleStyle = { color: "#0077cc", marginBottom: 20 };

const buttonStyle = {
    padding: "10px 25px",
    background: "#0077cc",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
};

const formGrid = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 20,
};

const inputStyle = {
    width: "100%",
    padding: 10,
    borderRadius: 6,
    border: "1px solid #ccc",
};

const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: 15,
};

export default ClassSectionWorkingDays;
